import React from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export const Lightbox = ({ image, onNavigate, onClose }) => (
  <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" style={{ background: 'rgba(10,10,10,0.95)' }}>
    <div className="relative max-w-4xl max-h-full">
      <button onClick={onClose} className="absolute -top-12 right-0 text-[#C2C1B6] hover:text-[#C9A84C] transition-colors duration-200 z-10" aria-label="Close">
        <X className="w-8 h-8" />
      </button>
      <button onClick={() => onNavigate('prev')} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#C2C1B6] hover:text-[#C9A84C] transition-colors duration-200 z-10" aria-label="Previous">
        <ChevronLeft className="w-8 h-8" />
      </button>
      <button onClick={() => onNavigate('next')} className="absolute right-4 top-1/2 -translate-y-1/2 text-[#C2C1B6] hover:text-[#C9A84C] transition-colors duration-200 z-10" aria-label="Next">
        <ChevronRight className="w-8 h-8" />
      </button>
      <img src={image.src} alt={`Gallery ${image.index + 1}`} className="max-w-full max-h-[85vh] object-contain" />
    </div>
  </div>
);
